<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>PROPERTY MANAGEMENT REPORT</h4>
			</div>

			<div class="col-md-12 mb-3">
				<el-row class="scrollable-row">
					<el-button :type="tabIndex == 0 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(0)"> <i class="fa fa-angle-down"></i> &nbsp; Detail</el-button>
					<el-button :type="tabIndex == 1 ? 'primary' : 'plain'" class="" size="medium" @click="selectTab(1)"> <i class="fa fa-angle-down"></i> &nbsp; Space SPBU</el-button>
					<el-button :type="tabIndex == item.index ? 'primary' : 'plain'" class="" size="medium" v-for="(item, index) in tabListReportIfca" :key="'btn-tab-'+index" @click="selectTab(item.index)"> <i class="fa fa-angle-down"></i> &nbsp; {{ item.label }}</el-button>
				</el-row>
			</div>

			<div class="col-md-12 mb-2">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
					<div> 
						<div>
							<ReportDetail v-show="tabIndex == 0" :tabIndex="'0'" :tabName="'detail'" :tabLabel="'Detail'" :showTitle="true"/>
						</div>
						<div>
							<ReportSpaceSPBU v-show="tabIndex == 1" :tabIndex="'1'" :tabName="'space-spbu'" :tabLabel="'Space SPBU'" :showTitle="true"/>
						</div>
						<div v-for="(item, index) in tabListReportIfca" :label="item.label" :name="item.index" :key="index" >
							<ReportIfca v-show="tabIndex == item.index" :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label" :showTitle="true"/>
						</div>
					</div>
				</el-card>	
			</div>

			<div class="col-md-12" v-if="false">
				<el-card class="box-card col-md-12 mb-4">
                    <div slot="header" class="clearfix">
                        <strong><span>PROPERTY MANAGEMENT REPORT</span></strong>
                    </div>
                    <div style="margin-top:-21px; margin-right:-20px; margin-left:-20px;">
						<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
							<el-tab-pane :label="'Detail'" :name="'0'"  >
								<ReportDetail :tabIndex="'0'" :tabName="'detail'" :tabLabel="'Detail'"/>
							</el-tab-pane>
							<el-tab-pane :label="'Space SPBU'" :name="'1'"  >
								<ReportSpaceSPBU :tabIndex="'1'" :tabName="'space-spbu'" :tabLabel="'Space SPBU'"/>
							</el-tab-pane>

							<el-tab-pane :label="'IFCA Billing'" :name="'2'"  >
								<ReportIfca :tabIndex="'2'" :tabName="'ifca-billing'" :tabLabel="'IFCA Billing'"/>
							</el-tab-pane>
							<el-tab-pane :label="'IFCA Invoice'" :name="'3'"  >
								<ReportIfca :tabIndex="'3'" :tabName="'ifca-invoice'" :tabLabel="'IFCA Invoice'"/>
							</el-tab-pane>
							<el-tab-pane :label="'IFCA Invoice Detail'" :name="'8'"  >
								<ReportIfca :tabIndex="'8'" :tabName="'ifca-invoice-detail'" :tabLabel="'IFCA Invoice Detail'"/>
							</el-tab-pane>
							<el-tab-pane :label="'IFCA Expired Contract Alert'" :name="'4'"  >
								<ReportIfca :tabIndex="'4'" :tabName="'ifca-contract-alert'" :tabLabel="'IFCA Expired Contract Alert'"/>
							</el-tab-pane>
							<el-tab-pane :label="'IFCA Total Tenant'" :name="'5'"  >
								<ReportIfca :tabIndex="'5'" :tabName="'ifca-total-contract'" :tabLabel="'IFCA Total Tenant'"/>
							</el-tab-pane>
							<el-tab-pane :label="'IFCA Contract Price'" :name="'6'" >
								<ReportIfca :tabIndex="'6'" :tabName="'ifca-total-contract-price'" :tabLabel="'IFCA Contract Price'"/>
							</el-tab-pane>
							<el-tab-pane :label="'IFCA Contract Detail'" :name="'7'" >
								<ReportIfca :tabIndex="'7'" :tabName="'ifca-total-contract-detail'" :tabLabel="'IFCA Contract Detail'"/>
							</el-tab-pane>

						</el-tabs>		
                    </div>
                </el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'

import ReportDetail from '@/views/pages/PropertyManagement/Report/ReportDetail.vue'
import ReportSpaceSPBU from '@/views/pages/PropertyManagement/Report/ReportSpaceSPBU.vue'
import ReportIfca from '@/views/pages/PropertyManagement/Report/ReportIfca.vue'

export default{
	extends: Fuel,
	components:{
		ReportDetail,
		ReportSpaceSPBU,
		ReportIfca,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabListReportIfca:[
				{label:'IFCA Billing', name: 'ifca-billing', index: '2' },
				{label:'IFCA Invoice', name: 'ifca-invoice', index: '3' },
				{label:'IFCA Invoice Detail', name: 'ifca-invoice-detail', index: '8' },
				{label:'IFCA Expired Contract Alert', name: 'ifca-contract-alert', index: '4' },
				{label:'IFCA Total Tenant', name: 'ifca-total-contract', index: '5' },
				{label:'IFCA Contract Price', name: 'ifca-total-contract-price', index: '6' },
				{label:'IFCA Contract Detail', name: 'ifca-total-contract-detail', index: '7' },
			],
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted() {
		this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

		selectTab(index) {
			this.tabIndex = `${index}`; //String(index);
			//console.log('index: ' + index);
		}
	}
}
</script>